import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CenterPage extends Component {

  static propTypes = {
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
    className: PropTypes.string,
    flexStyle: PropTypes.object,
    style: PropTypes.object,
  }

  static defaultProps = {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    className: '',
    flexStyle: {},
    style: {},
  }

  getSizeClassName() {
    const { xs, sm, md, lg, xl } = this.props;
    var finalClassName = '';

    if (xs) finalClassName += ' CenterPage--xs';
    if (sm) finalClassName += ' CenterPage--sm';
    if (md) finalClassName += ' CenterPage--md';
    if (lg) finalClassName += ' CenterPage--lg';
    if (xl) finalClassName += ' CenterPage--xl';

    return finalClassName;
  }

  render() {
    const {
      className,
      children,
      flexStyle,
      style,
    } = this.props;

    return (
      <div
        className={`CenterPage ${this.getSizeClassName()} ${className}`}
        style={flexStyle}
      >
        <div
          className="CenterPage_childContainer"
          style={style}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default CenterPage;



// WEBPACK FOOTER //
// ./src/components/CenterPage/CenterPage.js